import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Pais } from "app/main/_model";
import { config } from "environments/config";

@Injectable({
    providedIn: "root",
})
export class PaisService {
    constructor(private http: HttpClient) {}

    getListPais() {
        return this.http
            .get<any>(`${config.apiUrl}/pais/listar`)
            .toPromise()
            .then((res) => <Pais[]>res.data)
            .then((data) => {
                return data;
            });
    }
}
